import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface ServiceHeaderProps {
  onAddNewService: () => void;
}

export const ServiceHeader = ({ onAddNewService }: ServiceHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
      <div className="mt-4 md:mt-0 ml-auto">
        <Button 
          onClick={onAddNewService} 
          className="w-full md:w-auto"
          variant="gradient"
        >
          {t('services.addService')}
        </Button>
      </div>
    </div>
  );
};
